import { Center, Spinner } from '@vimeo/bokeh';

export const LoadingPage = () => (
  <Center flex="1" h="100vh">
    <Spinner />
  </Center>
);
